import { KeyboardEvent, MouseEvent, useEffect, useState } from 'react';
import { get, post, useAuth } from '../api';

function isMobileUserAgent() {
  const agent = navigator.userAgent;
  return (
    agent.match(/Android/i) ||
    agent.match(/webOS/i) ||
    agent.match(/iPhone/i) ||
    agent.match(/iPad/i) ||
    agent.match(/iPod/i) ||
    agent.match(/BlackBerry/i) ||
    agent.match(/Windows Phone/i)
  );
}

export default function Conversation({ conversationId }: any) {
  const [conversation, setConversation] = useState<any>();
  const reload = async () =>
    get(`messages/${conversationId}`)
      .then(setConversation)
      .catch(() => {});
  useEffect(() => {
    reload();
  }, []);

  const auth = useAuth();

  const [draftMessage, setDraftMessage] = useState('');

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && !event.shiftKey && !isMobileUserAgent()) {
      handleSubmit(event);
    }
  };

  const handleSubmit = async (event: KeyboardEvent | MouseEvent) => {
    event.preventDefault();
    if (!draftMessage.trim()) {
      return;
    }
    setDraftMessage('');
    try {
      await post(`messages/${conversationId}`, {
        content: draftMessage.trim(),
      });
    } catch (e) {
      return;
    }
    await reload();
  };

  if (!conversation) {
    return <span>Loading...</span>;
  }

  return (
    <div className="card" key={conversation.id}>
      <div className="card-header">
        <div className="card-header-title">{conversation.name}</div>
        <div className="tags are-medium mr-2">
          {conversation.participants
            .filter(({ id }: any) => id !== auth?.sub)
            .map((participant: any) => (
              <span className="tag">{participant.username}</span>
            ))}
        </div>
      </div>
      <div className="card-content">
        {conversation.messages.map((message: any) => {
          const isSender = message.sender.id === auth?.sub;
          return (
            <div className={`message ${isSender ? 'is-primary ml-6' : 'mr-6'}`}>
              <div className="message-header">
                <div>{message.sender.username}</div>
                <div>{formatDate(message.createdOn)}</div>
              </div>
              <div className="message-body">
                <div>
                  {message.content
                    .split('\n')
                    .flatMap((line: string, i: number) =>
                      i === 0 ? (
                        line
                      ) : (
                        <>
                          <br />
                          {line}
                        </>
                      )
                    )}
                </div>
              </div>
            </div>
          );
        })}
        <textarea
          className="textarea"
          value={draftMessage}
          onChange={(event) => setDraftMessage(event.target.value)}
          onKeyDown={handleKeyDown}
        />
        <div className="has-text-right mt-2">
          <button
            className="button is-primary"
            type="button"
            disabled={!draftMessage.trim()}
            onClick={handleSubmit}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}

function formatDate(dateString: string) {
  const date = new Date(dateString);

  const isToday = date.toDateString() === new Date().toDateString();
  if (isToday) {
    return date.toLocaleString(undefined, { timeStyle: 'short' });
  }

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const isYesterday = date.toDateString() === yesterday.toDateString();
  if (isYesterday) {
    return `Yesterday, ${date.toLocaleString(undefined, {
      timeStyle: 'short',
    })}`;
  }

  return date.toLocaleString(undefined, {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}
